/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:23 2019-07-15
 */

import EnumItem, {enumMixn} from "./enumItem";

/**
 * 模板类型
 */
let EnumAlarmType = {
	Overproof                 : new EnumItem('因子超标', 1, 'over_warning'),
	BatteryLow                : new EnumItem('电量不足', 2, 'power_low'),
	DevieceOffset             : new EnumItem('设备偏移', 3, 'device_lost'),
	DeviceNotEnoughTime       : new EnumItem('设备维护周期不足', 4, 'over_time'),
	InstrumentMalfunctionAlarm: new EnumItem('仪表故障告警', 5, 'meter_break'),
	DeveiceOffline            : new EnumItem('设备离线', 6, 'device_offline'),
	InstrumentCommonAlarm     : new EnumItem('仪表常规告警', 7, 'meter_warning'),
	SysMalfunctionAlarm       : new EnumItem('系统故障告警', 8, 'sys_break'),

	...enumMixn
}
export default EnumAlarmType
